<template>
  <div class="tree-wrap">
    <div class="project-selector">
      <el-row :gutter="10">
        <el-col :span="16">
          <el-select
            size="mini"
            style="width: 100%"
            v-model="jurisdictionId"
            filterable
            remote
            reserve-keyword
            clearable
            placeholder="请输入战区名称搜索"
            :loading="loading"
            class="kuan"
            @clear="getZoneList">
            <el-option
              v-for="item in jurisdictionList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8">
          <el-button title="点击重新刷新房产树" size="mini" @click="getDataObj" icon="el-icon-refresh" circle></el-button>
        </el-col>
      </el-row>
    </div>
    <div class="el-tree-1" :style="{height: height}">
      <el-tree ref="tree" :data="data" :empty-text="emptyText" :props="defaultProps" :lazy="true" :load="getData" @node-click="nodeClick">
        <div slot-scope="{ node }">
          <span v-if="node.data.type==='room'" class="fangtai" :class="roomStatusIoc(node.data.room_status_ids)"></span>
          <span class="fangtai-name">{{ node.label }}</span>
      </div>
      </el-tree>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'erp-tree-status-common',
    props: {
      api: {
        type: String,
        default() {
          return ""
        }
      },
      height:{
        type:String,
        default() {
            return "calc( 100vh - 220px )";
        }
      }
    },
    data() {
      return {
        jurisdictionId: '',
        jurisdictionList: [],
        projectId: 0,
        building: '',
        unit: '',
        data: [],
        emptyText: '没有数据',
        defaultProps: {
          label: 'name',
          isLeaf: 'leaf',
        },
        loading: false,
      }
    },
    created() {
      this.getJurisdiction()
      this.getZoneList()
    },
    watch: {
      jurisdictionId(val) {
        this.getZoneList()
      }
    },
    methods: {
      getDataObj(){
        this.data=[];
        this.jurisdictionId= '';
        this.jurisdictionList= [];
        this.projectId=0;
        this.building=''
        this.unit=''
        this.defaultProps= {
          label: 'name',
          isLeaf: 'leaf',
        }
        this.getJurisdiction()
        this.getZoneList()
      },
      // 获得自己和自己名下的架构
      getJurisdiction() {
        this.$myhttp.get('admin/common/jurisdiction',{
        'Content-Type': 'application/json'
        }).then(backdata=>{
        	if(backdata.data.code == 200) {
        	  this.jurisdictionList = backdata.data.data
        	} else {
            this.$message.error(backdata.data.message);
        	}
        });
      },
      getZoneList() {
          const that=this;
          that.$myhttp.get('admin/common/zone?zoneId=' + this.jurisdictionId,{
            'Content-Type': 'application/json'
          }).then(backdata=>{
            if(backdata.data.code == 200) {
              that.jurisdictionList = backdata.data.data;
              that.data = backdata.data.data.map((item) => {
                return {
                  'name':item.name,
                  'id':item.id,
                  'region':0,
                  'type':'zone',
                  'pindex_id':0,
                  superior:'0',
                  'projectId':item.pindex_id,
                  dataObj:item
                }
              })
            } else {
              this.$message.error(backdata.data.message);
            }
          });
      },
      // 获得自己名下的所有项目
      getData(node, resolve) {

        //console.log(node.level, node.data)
        var region_id = node.data.id;
        //console.log(region_id);
        var _this = this;
        setTimeout(() => {
          if(region_id == '' || region_id == undefined){
            return false;
          }
          //加载
          node.data.region_id = region_id;
          node.data && this.$myhttp.post('admin/common/getbindingArrsV2',node.data,{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            // _this.defaultcheckedkeys =  _this.arr;
            return resolve(backdata.data);
          });
        }, 300);
      },
      nodeClick(data, node) {
        var d = {
          level: node.level,
          type: node.data.type,
          id: node.data.id,
          name: node.data.name,
          tree:nodeToList(node)
        }
        this.$emit('node-click', d)
      },
      roomStatusIoc(ids){

        let icons=['kongzhi','weiling','kongguan','zhuangxiu','ruzhu','chuzu','tingyong','qita']

        try {
          ids.findIndex(',')!==-1&&(ids=ids.split(','),ids=ids[0]);
        }catch (e) {
          console.log(ids)
        }

        return 'fangtai_'+icons[ids-1]
      },
      remoteMethod(query) {
        if (query !== "") {
          this.loading = true;
          setTimeout(() => {
            this.$myhttp
              .post(
                "admin/common/searchProject",
                { keyword: query },
                {
                  "Content-Type": "application/json",
                }
              )
              .then((backdata) => {
                if (backdata.data.code == 200) {
                  this.jurisdictionList = backdata.data.data;
                } else {
                  this.$message.error(backdata.data.message);
                }
              });
            this.loading = false;
          }, 200);
        }
      },
    }
  }

  function nodeToList(node) {
    let node_list=[]
    node_list[10]=node.data;
    let nodeObj=node
    for(let i=9;i>0;i--){
      nodeObj['parent']&&(nodeObj=nodeObj['parent'],node_list[i]=nodeObj.data[0]?nodeObj.data[0]:nodeObj.data);
    }
    return node_list.filter(ret=>{return ret}).splice(1)
  }
</script>

<style lang="scss">
  .el-tree-1{
    overflow-y: scroll;
    //height: calc( 100vh - 120px );
    width: 100%;
  }
  .tree-wrap {
    width: 250px;
  }

  .fangtai{
    width: 18px;
    height: 18px;
    margin-right: 25px;
    position: relative;
    &::before{
      content: " ";
      position: absolute;
      width: 18px;
      height: 18px;
      right: 0;
      left: 0;
      top: 0;
      bottom: 0;
      background-image: url("../../../assets/image/fangtai/chuzu.png");
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      z-index: 99;
    }
  }
  $icons:chuzu,kongguan,kongzhi,ruzhu,zhuangxiu,tingyong,weiling;
  @each $i in $icons{
    .fangtai_#{$i}{
      &::before{
        background-image: url("../../../assets/image/fangtai/#{$i}.png");
      }
    }
  }
  .fangtai-name{

  }

  .project-selector {
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Common/erp-tree-status-v2.vue